import { Container, Row, Col } from 'react-bootstrap';
import HostButtons from '@website/components/hosts/hostPage/hostButtons';
import SeoMetaTags from '@website/components/seoMetaTags';
import { HostTripsCard } from '@website/components/hosts/hostPage/tripsCard';
import { HostPageContentProps } from '@website/components/hosts/hostPage/types';
import useCheckHostPermissions from '@website/hooks/useCheckHostPermissions';
import { useQuery } from '@apollo/client/react';
import { HostPageDetailsDocument } from '@website/types/graphqlOperations';
import LoadingPage from '@website/components/utilities/LoadingPage';
import NotFound from '@website/components/utilities/NotFound';
import ErrorPage from '@website/components/utilities/ErrorPage';

export function HostPageContent({
  urlSlug,
}: HostPageContentProps): JSX.Element {
  const { loading, data, error } = useQuery(HostPageDetailsDocument, {
    variables: {
      urlSlug,
    },
  });

  const { isAuthorized } = useCheckHostPermissions(urlSlug);

  if (loading && !data) {
    return <LoadingPage />;
  }

  // Show 404 if not found
  if (error?.message?.includes('Cannot return null')) {
    return <NotFound />;
  }

  // Show errors except if we have a network error from polling
  if (error && !data) {
    return <ErrorPage error={error} />;
  }

  const host = data?.hostByURL;

  return (
    <>
      <SeoMetaTags
        title={host.name}
        description={host.about}
        // imageKey={host?.image?.key}
      />

      <div className="Company mt-5">
        <Container>
          <Row className="mx-auto">
            <Col className="p-2">
              <h2 aria-level={2} className="h1">
                {host.name}
              </h2>
            </Col>
          </Row>
          {isAuthorized && (
            <Row className="mx-auto">
              <Col className="p-2">
                <HostButtons urlSlug={host.urlSlug} />
              </Col>
            </Row>
          )}
          <Row className="mx-auto">
            <Col className="p-2" role="banner">
              <p className="lead">{host.about}</p>
            </Col>
          </Row>

          <Row className="mx-auto">
            <Col className="p-2">
              <HostTripsCard trips={host.trips.items} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
